export default "__VITE_ASSET__CmRe4lsZ__"